import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'w-full cursor-pointer appearance-none rounded-lg border border-input bg-surface bg-[url("data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%2712%27%20height%3D%2712%27%20viewBox%3D%270%200%2024%2024%27%20fill%3D%27none%27%3E%3Cpath%20d%3D%27M6%209l6%206%206-6%27%20stroke%3D%27%23777%27%20stroke-width%3D%272%27%2F%3E%3C%2Fsvg%3E")] bg-[position:right_12px_center] bg-no-repeat px-3 py-2.5 pr-9 text-sm text-fg outline-none transition-colors focus:border-primary',
        className,
      )}
      {...props}
    />
  ),
);
Select.displayName = 'Select';
